// Guardian AI Compliance Service Protocol Definitions
// Audit logging, consent management, scan consent, and reporting
//
// Version: v1
// Source: Merged from backend compliance.proto + frontend compliance.proto (DSR)

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/compliance/compliance.proto (package guardianai.v1.compliance, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/compliance/compliance.proto.
 */
export const file_guardianai_v1_compliance_compliance: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.compliance.DsrRequest
 */
export type DsrRequest = Message<"guardianai.v1.compliance.DsrRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: guardianai.v1.compliance.DsrType type = 2;
   */
  type: DsrType;

  /**
   * @generated from field: string details = 3;
   */
  details: string;
};

/**
 * @generated from message guardianai.v1.compliance.DsrRequest
 */
export type DsrRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: guardianai.v1.compliance.DsrType type = 2;
   */
  type?: DsrTypeJson;

  /**
   * @generated from field: string details = 3;
   */
  details?: string;
};

/**
 * Describes the message guardianai.v1.compliance.DsrRequest.
 * Use `create(DsrRequestSchema)` to create a new message.
 */
export const DsrRequestSchema: GenMessage<DsrRequest, {jsonType: DsrRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 0);

/**
 * @generated from message guardianai.v1.compliance.DsrResponse
 */
export type DsrResponse = Message<"guardianai.v1.compliance.DsrResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string download_url = 2;
   */
  downloadUrl: string;

  /**
   * @generated from field: string error_message = 3;
   */
  errorMessage: string;
};

/**
 * @generated from message guardianai.v1.compliance.DsrResponse
 */
export type DsrResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string download_url = 2;
   */
  downloadUrl?: string;

  /**
   * @generated from field: string error_message = 3;
   */
  errorMessage?: string;
};

/**
 * Describes the message guardianai.v1.compliance.DsrResponse.
 * Use `create(DsrResponseSchema)` to create a new message.
 */
export const DsrResponseSchema: GenMessage<DsrResponse, {jsonType: DsrResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 1);

/**
 * @generated from message guardianai.v1.compliance.LogEventRequest
 */
export type LogEventRequest = Message<"guardianai.v1.compliance.LogEventRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;

  /**
   * @generated from field: string resource_id = 4;
   */
  resourceId: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: string ip_address = 6;
   */
  ipAddress: string;
};

/**
 * @generated from message guardianai.v1.compliance.LogEventRequest
 */
export type LogEventRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string action = 2;
   */
  action?: string;

  /**
   * @generated from field: string resource_type = 3;
   */
  resourceType?: string;

  /**
   * @generated from field: string resource_id = 4;
   */
  resourceId?: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata?: { [key: string]: string };

  /**
   * @generated from field: string ip_address = 6;
   */
  ipAddress?: string;
};

/**
 * Describes the message guardianai.v1.compliance.LogEventRequest.
 * Use `create(LogEventRequestSchema)` to create a new message.
 */
export const LogEventRequestSchema: GenMessage<LogEventRequest, {jsonType: LogEventRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 2);

/**
 * @generated from message guardianai.v1.compliance.LogEventResponse
 */
export type LogEventResponse = Message<"guardianai.v1.compliance.LogEventResponse"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: bool logged = 2;
   */
  logged: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.LogEventResponse
 */
export type LogEventResponseJson = {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId?: string;

  /**
   * @generated from field: bool logged = 2;
   */
  logged?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.LogEventResponse.
 * Use `create(LogEventResponseSchema)` to create a new message.
 */
export const LogEventResponseSchema: GenMessage<LogEventResponse, {jsonType: LogEventResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 3);

/**
 * @generated from message guardianai.v1.compliance.GetAuditLogRequest
 */
export type GetAuditLogRequest = Message<"guardianai.v1.compliance.GetAuditLogRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetAuditLogRequest
 */
export type GetAuditLogRequestJson = {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetAuditLogRequest.
 * Use `create(GetAuditLogRequestSchema)` to create a new message.
 */
export const GetAuditLogRequestSchema: GenMessage<GetAuditLogRequest, {jsonType: GetAuditLogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 4);

/**
 * @generated from message guardianai.v1.compliance.AuditLogResponse
 */
export type AuditLogResponse = Message<"guardianai.v1.compliance.AuditLogResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.AuditEvent events = 1;
   */
  events: AuditEvent[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.compliance.AuditLogResponse
 */
export type AuditLogResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.AuditEvent events = 1;
   */
  events?: AuditEventJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.compliance.AuditLogResponse.
 * Use `create(AuditLogResponseSchema)` to create a new message.
 */
export const AuditLogResponseSchema: GenMessage<AuditLogResponse, {jsonType: AuditLogResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 5);

/**
 * @generated from message guardianai.v1.compliance.AuditEvent
 */
export type AuditEvent = Message<"guardianai.v1.compliance.AuditEvent"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: string resource_type = 4;
   */
  resourceType: string;

  /**
   * @generated from field: string resource_id = 5;
   */
  resourceId: string;

  /**
   * @generated from field: string ip_address = 6;
   */
  ipAddress: string;

  /**
   * @generated from field: int64 timestamp = 7;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.AuditEvent
 */
export type AuditEventJson = {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string action = 3;
   */
  action?: string;

  /**
   * @generated from field: string resource_type = 4;
   */
  resourceType?: string;

  /**
   * @generated from field: string resource_id = 5;
   */
  resourceId?: string;

  /**
   * @generated from field: string ip_address = 6;
   */
  ipAddress?: string;

  /**
   * @generated from field: int64 timestamp = 7;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.compliance.AuditEvent.
 * Use `create(AuditEventSchema)` to create a new message.
 */
export const AuditEventSchema: GenMessage<AuditEvent, {jsonType: AuditEventJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 6);

/**
 * @generated from message guardianai.v1.compliance.SearchLogsRequest
 */
export type SearchLogsRequest = Message<"guardianai.v1.compliance.SearchLogsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * @generated from field: string resource_type = 3;
   */
  resourceType: string;

  /**
   * @generated from field: int64 start_time = 4;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 5;
   */
  endTime: bigint;

  /**
   * @generated from field: int32 limit = 6;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.compliance.SearchLogsRequest
 */
export type SearchLogsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string action = 2;
   */
  action?: string;

  /**
   * @generated from field: string resource_type = 3;
   */
  resourceType?: string;

  /**
   * @generated from field: int64 start_time = 4;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 5;
   */
  endTime?: string;

  /**
   * @generated from field: int32 limit = 6;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.compliance.SearchLogsRequest.
 * Use `create(SearchLogsRequestSchema)` to create a new message.
 */
export const SearchLogsRequestSchema: GenMessage<SearchLogsRequest, {jsonType: SearchLogsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 7);

/**
 * @generated from message guardianai.v1.compliance.GetUserActivityRequest
 */
export type GetUserActivityRequest = Message<"guardianai.v1.compliance.GetUserActivityRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.compliance.GetUserActivityRequest
 */
export type GetUserActivityRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.compliance.GetUserActivityRequest.
 * Use `create(GetUserActivityRequestSchema)` to create a new message.
 */
export const GetUserActivityRequestSchema: GenMessage<GetUserActivityRequest, {jsonType: GetUserActivityRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 8);

/**
 * @generated from message guardianai.v1.compliance.UserActivityResponse
 */
export type UserActivityResponse = Message<"guardianai.v1.compliance.UserActivityResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.AuditEvent activities = 1;
   */
  activities: AuditEvent[];
};

/**
 * @generated from message guardianai.v1.compliance.UserActivityResponse
 */
export type UserActivityResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.AuditEvent activities = 1;
   */
  activities?: AuditEventJson[];
};

/**
 * Describes the message guardianai.v1.compliance.UserActivityResponse.
 * Use `create(UserActivityResponseSchema)` to create a new message.
 */
export const UserActivityResponseSchema: GenMessage<UserActivityResponse, {jsonType: UserActivityResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 9);

/**
 * @generated from message guardianai.v1.compliance.ExportLogRequest
 */
export type ExportLogRequest = Message<"guardianai.v1.compliance.ExportLogRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;

  /**
   * @generated from field: string format = 3;
   */
  format: string;
};

/**
 * @generated from message guardianai.v1.compliance.ExportLogRequest
 */
export type ExportLogRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;

  /**
   * @generated from field: string format = 3;
   */
  format?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ExportLogRequest.
 * Use `create(ExportLogRequestSchema)` to create a new message.
 */
export const ExportLogRequestSchema: GenMessage<ExportLogRequest, {jsonType: ExportLogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 10);

/**
 * @generated from message guardianai.v1.compliance.ExportResponse
 */
export type ExportResponse = Message<"guardianai.v1.compliance.ExportResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string format = 2;
   */
  format: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.compliance.ExportResponse
 */
export type ExportResponseJson = {
  /**
   * @generated from field: bytes data = 1;
   */
  data?: string;

  /**
   * @generated from field: string format = 2;
   */
  format?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ExportResponse.
 * Use `create(ExportResponseSchema)` to create a new message.
 */
export const ExportResponseSchema: GenMessage<ExportResponse, {jsonType: ExportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 11);

/**
 * @generated from message guardianai.v1.compliance.GetSummaryRequest
 */
export type GetSummaryRequest = Message<"guardianai.v1.compliance.GetSummaryRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.GetSummaryRequest
 */
export type GetSummaryRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetSummaryRequest.
 * Use `create(GetSummaryRequestSchema)` to create a new message.
 */
export const GetSummaryRequestSchema: GenMessage<GetSummaryRequest, {jsonType: GetSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 12);

/**
 * @generated from message guardianai.v1.compliance.AuditSummaryResponse
 */
export type AuditSummaryResponse = Message<"guardianai.v1.compliance.AuditSummaryResponse"> & {
  /**
   * @generated from field: int64 total_events = 1;
   */
  totalEvents: bigint;

  /**
   * @generated from field: map<string, int64> by_action = 2;
   */
  byAction: { [key: string]: bigint };

  /**
   * @generated from field: map<string, int64> by_user = 3;
   */
  byUser: { [key: string]: bigint };
};

/**
 * @generated from message guardianai.v1.compliance.AuditSummaryResponse
 */
export type AuditSummaryResponseJson = {
  /**
   * @generated from field: int64 total_events = 1;
   */
  totalEvents?: string;

  /**
   * @generated from field: map<string, int64> by_action = 2;
   */
  byAction?: { [key: string]: string };

  /**
   * @generated from field: map<string, int64> by_user = 3;
   */
  byUser?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.compliance.AuditSummaryResponse.
 * Use `create(AuditSummaryResponseSchema)` to create a new message.
 */
export const AuditSummaryResponseSchema: GenMessage<AuditSummaryResponse, {jsonType: AuditSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 13);

/**
 * @generated from message guardianai.v1.compliance.SetRetentionRequest
 */
export type SetRetentionRequest = Message<"guardianai.v1.compliance.SetRetentionRequest"> & {
  /**
   * @generated from field: int32 retention_days = 1;
   */
  retentionDays: number;
};

/**
 * @generated from message guardianai.v1.compliance.SetRetentionRequest
 */
export type SetRetentionRequestJson = {
  /**
   * @generated from field: int32 retention_days = 1;
   */
  retentionDays?: number;
};

/**
 * Describes the message guardianai.v1.compliance.SetRetentionRequest.
 * Use `create(SetRetentionRequestSchema)` to create a new message.
 */
export const SetRetentionRequestSchema: GenMessage<SetRetentionRequest, {jsonType: SetRetentionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 14);

/**
 * @generated from message guardianai.v1.compliance.GetRetentionRequest
 */
export type GetRetentionRequest = Message<"guardianai.v1.compliance.GetRetentionRequest"> & {
};

/**
 * @generated from message guardianai.v1.compliance.GetRetentionRequest
 */
export type GetRetentionRequestJson = {
};

/**
 * Describes the message guardianai.v1.compliance.GetRetentionRequest.
 * Use `create(GetRetentionRequestSchema)` to create a new message.
 */
export const GetRetentionRequestSchema: GenMessage<GetRetentionRequest, {jsonType: GetRetentionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 15);

/**
 * @generated from message guardianai.v1.compliance.RetentionResponse
 */
export type RetentionResponse = Message<"guardianai.v1.compliance.RetentionResponse"> & {
  /**
   * @generated from field: int32 retention_days = 1;
   */
  retentionDays: number;
};

/**
 * @generated from message guardianai.v1.compliance.RetentionResponse
 */
export type RetentionResponseJson = {
  /**
   * @generated from field: int32 retention_days = 1;
   */
  retentionDays?: number;
};

/**
 * Describes the message guardianai.v1.compliance.RetentionResponse.
 * Use `create(RetentionResponseSchema)` to create a new message.
 */
export const RetentionResponseSchema: GenMessage<RetentionResponse, {jsonType: RetentionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 16);

/**
 * @generated from message guardianai.v1.compliance.PurgeLogsRequest
 */
export type PurgeLogsRequest = Message<"guardianai.v1.compliance.PurgeLogsRequest"> & {
  /**
   * @generated from field: int64 before_date = 1;
   */
  beforeDate: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.PurgeLogsRequest
 */
export type PurgeLogsRequestJson = {
  /**
   * @generated from field: int64 before_date = 1;
   */
  beforeDate?: string;
};

/**
 * Describes the message guardianai.v1.compliance.PurgeLogsRequest.
 * Use `create(PurgeLogsRequestSchema)` to create a new message.
 */
export const PurgeLogsRequestSchema: GenMessage<PurgeLogsRequest, {jsonType: PurgeLogsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 17);

/**
 * @generated from message guardianai.v1.compliance.PurgeResponse
 */
export type PurgeResponse = Message<"guardianai.v1.compliance.PurgeResponse"> & {
  /**
   * @generated from field: int64 purged_count = 1;
   */
  purgedCount: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.PurgeResponse
 */
export type PurgeResponseJson = {
  /**
   * @generated from field: int64 purged_count = 1;
   */
  purgedCount?: string;
};

/**
 * Describes the message guardianai.v1.compliance.PurgeResponse.
 * Use `create(PurgeResponseSchema)` to create a new message.
 */
export const PurgeResponseSchema: GenMessage<PurgeResponse, {jsonType: PurgeResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 18);

/**
 * @generated from message guardianai.v1.compliance.GetCompReportRequest
 */
export type GetCompReportRequest = Message<"guardianai.v1.compliance.GetCompReportRequest"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * @generated from field: int64 period_start = 2;
   */
  periodStart: bigint;

  /**
   * @generated from field: int64 period_end = 3;
   */
  periodEnd: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.GetCompReportRequest
 */
export type GetCompReportRequestJson = {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType?: string;

  /**
   * @generated from field: int64 period_start = 2;
   */
  periodStart?: string;

  /**
   * @generated from field: int64 period_end = 3;
   */
  periodEnd?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetCompReportRequest.
 * Use `create(GetCompReportRequestSchema)` to create a new message.
 */
export const GetCompReportRequestSchema: GenMessage<GetCompReportRequest, {jsonType: GetCompReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 19);

/**
 * @generated from message guardianai.v1.compliance.ComplianceReportResponse
 */
export type ComplianceReportResponse = Message<"guardianai.v1.compliance.ComplianceReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;

  /**
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * @generated from field: int64 generated_at = 4;
   */
  generatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.ComplianceReportResponse
 */
export type ComplianceReportResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: bytes content = 2;
   */
  content?: string;

  /**
   * @generated from field: string format = 3;
   */
  format?: string;

  /**
   * @generated from field: int64 generated_at = 4;
   */
  generatedAt?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ComplianceReportResponse.
 * Use `create(ComplianceReportResponseSchema)` to create a new message.
 */
export const ComplianceReportResponseSchema: GenMessage<ComplianceReportResponse, {jsonType: ComplianceReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 20);

/**
 * @generated from message guardianai.v1.compliance.RecordConsentRequest
 */
export type RecordConsentRequest = Message<"guardianai.v1.compliance.RecordConsentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType: string;

  /**
   * @generated from field: bool granted = 3;
   */
  granted: boolean;

  /**
   * @generated from field: string version = 4;
   */
  version: string;
};

/**
 * @generated from message guardianai.v1.compliance.RecordConsentRequest
 */
export type RecordConsentRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType?: string;

  /**
   * @generated from field: bool granted = 3;
   */
  granted?: boolean;

  /**
   * @generated from field: string version = 4;
   */
  version?: string;
};

/**
 * Describes the message guardianai.v1.compliance.RecordConsentRequest.
 * Use `create(RecordConsentRequestSchema)` to create a new message.
 */
export const RecordConsentRequestSchema: GenMessage<RecordConsentRequest, {jsonType: RecordConsentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 21);

/**
 * @generated from message guardianai.v1.compliance.ConsentResponse
 */
export type ConsentResponse = Message<"guardianai.v1.compliance.ConsentResponse"> & {
  /**
   * @generated from field: string consent_id = 1;
   */
  consentId: string;

  /**
   * @generated from field: bool recorded = 2;
   */
  recorded: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.ConsentResponse
 */
export type ConsentResponseJson = {
  /**
   * @generated from field: string consent_id = 1;
   */
  consentId?: string;

  /**
   * @generated from field: bool recorded = 2;
   */
  recorded?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.ConsentResponse.
 * Use `create(ConsentResponseSchema)` to create a new message.
 */
export const ConsentResponseSchema: GenMessage<ConsentResponse, {jsonType: ConsentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 22);

/**
 * @generated from message guardianai.v1.compliance.GetConsentRequest
 */
export type GetConsentRequest = Message<"guardianai.v1.compliance.GetConsentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetConsentRequest
 */
export type GetConsentRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetConsentRequest.
 * Use `create(GetConsentRequestSchema)` to create a new message.
 */
export const GetConsentRequestSchema: GenMessage<GetConsentRequest, {jsonType: GetConsentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 23);

/**
 * @generated from message guardianai.v1.compliance.ConsentStatusResponse
 */
export type ConsentStatusResponse = Message<"guardianai.v1.compliance.ConsentStatusResponse"> & {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted: boolean;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: int64 granted_at = 4;
   */
  grantedAt: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.ConsentStatusResponse
 */
export type ConsentStatusResponseJson = {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType?: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted?: boolean;

  /**
   * @generated from field: string version = 3;
   */
  version?: string;

  /**
   * @generated from field: int64 granted_at = 4;
   */
  grantedAt?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ConsentStatusResponse.
 * Use `create(ConsentStatusResponseSchema)` to create a new message.
 */
export const ConsentStatusResponseSchema: GenMessage<ConsentStatusResponse, {jsonType: ConsentStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 24);

/**
 * @generated from message guardianai.v1.compliance.RevokeConsentRequest
 */
export type RevokeConsentRequest = Message<"guardianai.v1.compliance.RevokeConsentRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType: string;
};

/**
 * @generated from message guardianai.v1.compliance.RevokeConsentRequest
 */
export type RevokeConsentRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string consent_type = 2;
   */
  consentType?: string;
};

/**
 * Describes the message guardianai.v1.compliance.RevokeConsentRequest.
 * Use `create(RevokeConsentRequestSchema)` to create a new message.
 */
export const RevokeConsentRequestSchema: GenMessage<RevokeConsentRequest, {jsonType: RevokeConsentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 25);

/**
 * @generated from message guardianai.v1.compliance.RevokeResponse
 */
export type RevokeResponse = Message<"guardianai.v1.compliance.RevokeResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.RevokeResponse
 */
export type RevokeResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.RevokeResponse.
 * Use `create(RevokeResponseSchema)` to create a new message.
 */
export const RevokeResponseSchema: GenMessage<RevokeResponse, {jsonType: RevokeResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 26);

/**
 * @generated from message guardianai.v1.compliance.GetConsentHistoryRequest
 */
export type GetConsentHistoryRequest = Message<"guardianai.v1.compliance.GetConsentHistoryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetConsentHistoryRequest
 */
export type GetConsentHistoryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetConsentHistoryRequest.
 * Use `create(GetConsentHistoryRequestSchema)` to create a new message.
 */
export const GetConsentHistoryRequestSchema: GenMessage<GetConsentHistoryRequest, {jsonType: GetConsentHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 27);

/**
 * @generated from message guardianai.v1.compliance.ConsentHistoryResponse
 */
export type ConsentHistoryResponse = Message<"guardianai.v1.compliance.ConsentHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ConsentRecord history = 1;
   */
  history: ConsentRecord[];
};

/**
 * @generated from message guardianai.v1.compliance.ConsentHistoryResponse
 */
export type ConsentHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ConsentRecord history = 1;
   */
  history?: ConsentRecordJson[];
};

/**
 * Describes the message guardianai.v1.compliance.ConsentHistoryResponse.
 * Use `create(ConsentHistoryResponseSchema)` to create a new message.
 */
export const ConsentHistoryResponseSchema: GenMessage<ConsentHistoryResponse, {jsonType: ConsentHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 28);

/**
 * @generated from message guardianai.v1.compliance.ConsentRecord
 */
export type ConsentRecord = Message<"guardianai.v1.compliance.ConsentRecord"> & {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted: boolean;

  /**
   * @generated from field: string version = 3;
   */
  version: string;

  /**
   * @generated from field: int64 timestamp = 4;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.ConsentRecord
 */
export type ConsentRecordJson = {
  /**
   * @generated from field: string consent_type = 1;
   */
  consentType?: string;

  /**
   * @generated from field: bool granted = 2;
   */
  granted?: boolean;

  /**
   * @generated from field: string version = 3;
   */
  version?: string;

  /**
   * @generated from field: int64 timestamp = 4;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ConsentRecord.
 * Use `create(ConsentRecordSchema)` to create a new message.
 */
export const ConsentRecordSchema: GenMessage<ConsentRecord, {jsonType: ConsentRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 29);

/**
 * @generated from message guardianai.v1.compliance.GetActiveConsentsRequest
 */
export type GetActiveConsentsRequest = Message<"guardianai.v1.compliance.GetActiveConsentsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetActiveConsentsRequest
 */
export type GetActiveConsentsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetActiveConsentsRequest.
 * Use `create(GetActiveConsentsRequestSchema)` to create a new message.
 */
export const GetActiveConsentsRequestSchema: GenMessage<GetActiveConsentsRequest, {jsonType: GetActiveConsentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 30);

/**
 * @generated from message guardianai.v1.compliance.ActiveConsentsResponse
 */
export type ActiveConsentsResponse = Message<"guardianai.v1.compliance.ActiveConsentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ConsentStatusResponse consents = 1;
   */
  consents: ConsentStatusResponse[];
};

/**
 * @generated from message guardianai.v1.compliance.ActiveConsentsResponse
 */
export type ActiveConsentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ConsentStatusResponse consents = 1;
   */
  consents?: ConsentStatusResponseJson[];
};

/**
 * Describes the message guardianai.v1.compliance.ActiveConsentsResponse.
 * Use `create(ActiveConsentsResponseSchema)` to create a new message.
 */
export const ActiveConsentsResponseSchema: GenMessage<ActiveConsentsResponse, {jsonType: ActiveConsentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 31);

/**
 * @generated from message guardianai.v1.compliance.UpdatePreferencesRequest
 */
export type UpdatePreferencesRequest = Message<"guardianai.v1.compliance.UpdatePreferencesRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: map<string, bool> preferences = 2;
   */
  preferences: { [key: string]: boolean };
};

/**
 * @generated from message guardianai.v1.compliance.UpdatePreferencesRequest
 */
export type UpdatePreferencesRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: map<string, bool> preferences = 2;
   */
  preferences?: { [key: string]: boolean };
};

/**
 * Describes the message guardianai.v1.compliance.UpdatePreferencesRequest.
 * Use `create(UpdatePreferencesRequestSchema)` to create a new message.
 */
export const UpdatePreferencesRequestSchema: GenMessage<UpdatePreferencesRequest, {jsonType: UpdatePreferencesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 32);

/**
 * @generated from message guardianai.v1.compliance.PreferencesResponse
 */
export type PreferencesResponse = Message<"guardianai.v1.compliance.PreferencesResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.PreferencesResponse
 */
export type PreferencesResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.PreferencesResponse.
 * Use `create(PreferencesResponseSchema)` to create a new message.
 */
export const PreferencesResponseSchema: GenMessage<PreferencesResponse, {jsonType: PreferencesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 33);

/**
 * @generated from message guardianai.v1.compliance.RequestScanConsentRequest
 */
export type RequestScanConsentRequest = Message<"guardianai.v1.compliance.RequestScanConsentRequest"> & {
  /**
   * @generated from field: string scanner_user_id = 1;
   */
  scannerUserId: string;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId: string;

  /**
   * USER or ORGANIZATION
   *
   * @generated from field: string target_entity_type = 3;
   */
  targetEntityType: string;

  /**
   * PRE_REGISTRATION, POST_REGISTRATION, PAID_SCAN
   *
   * @generated from field: string scan_type = 4;
   */
  scanType: string;
};

/**
 * @generated from message guardianai.v1.compliance.RequestScanConsentRequest
 */
export type RequestScanConsentRequestJson = {
  /**
   * @generated from field: string scanner_user_id = 1;
   */
  scannerUserId?: string;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId?: string;

  /**
   * USER or ORGANIZATION
   *
   * @generated from field: string target_entity_type = 3;
   */
  targetEntityType?: string;

  /**
   * PRE_REGISTRATION, POST_REGISTRATION, PAID_SCAN
   *
   * @generated from field: string scan_type = 4;
   */
  scanType?: string;
};

/**
 * Describes the message guardianai.v1.compliance.RequestScanConsentRequest.
 * Use `create(RequestScanConsentRequestSchema)` to create a new message.
 */
export const RequestScanConsentRequestSchema: GenMessage<RequestScanConsentRequest, {jsonType: RequestScanConsentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 34);

/**
 * @generated from message guardianai.v1.compliance.RequestScanConsentResponse
 */
export type RequestScanConsentResponse = Message<"guardianai.v1.compliance.RequestScanConsentResponse"> & {
  /**
   * @generated from field: string consent_token = 1;
   */
  consentToken: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.RequestScanConsentResponse
 */
export type RequestScanConsentResponseJson = {
  /**
   * @generated from field: string consent_token = 1;
   */
  consentToken?: string;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: int64 expires_at = 3;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.compliance.RequestScanConsentResponse.
 * Use `create(RequestScanConsentResponseSchema)` to create a new message.
 */
export const RequestScanConsentResponseSchema: GenMessage<RequestScanConsentResponse, {jsonType: RequestScanConsentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 35);

/**
 * @generated from message guardianai.v1.compliance.VerifyScanConsentRequest
 */
export type VerifyScanConsentRequest = Message<"guardianai.v1.compliance.VerifyScanConsentRequest"> & {
  /**
   * @generated from field: string consent_token = 1;
   */
  consentToken: string;
};

/**
 * @generated from message guardianai.v1.compliance.VerifyScanConsentRequest
 */
export type VerifyScanConsentRequestJson = {
  /**
   * @generated from field: string consent_token = 1;
   */
  consentToken?: string;
};

/**
 * Describes the message guardianai.v1.compliance.VerifyScanConsentRequest.
 * Use `create(VerifyScanConsentRequestSchema)` to create a new message.
 */
export const VerifyScanConsentRequestSchema: GenMessage<VerifyScanConsentRequest, {jsonType: VerifyScanConsentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 36);

/**
 * @generated from message guardianai.v1.compliance.VerifyScanConsentResponse
 */
export type VerifyScanConsentResponse = Message<"guardianai.v1.compliance.VerifyScanConsentResponse"> & {
  /**
   * @generated from field: bool approved = 1;
   */
  approved: boolean;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId: string;

  /**
   * @generated from field: string scanner_user_id = 3;
   */
  scannerUserId: string;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.VerifyScanConsentResponse
 */
export type VerifyScanConsentResponseJson = {
  /**
   * @generated from field: bool approved = 1;
   */
  approved?: boolean;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId?: string;

  /**
   * @generated from field: string scanner_user_id = 3;
   */
  scannerUserId?: string;

  /**
   * @generated from field: int64 expires_at = 4;
   */
  expiresAt?: string;
};

/**
 * Describes the message guardianai.v1.compliance.VerifyScanConsentResponse.
 * Use `create(VerifyScanConsentResponseSchema)` to create a new message.
 */
export const VerifyScanConsentResponseSchema: GenMessage<VerifyScanConsentResponse, {jsonType: VerifyScanConsentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 37);

/**
 * @generated from message guardianai.v1.compliance.GetScanConsentStatusRequest
 */
export type GetScanConsentStatusRequest = Message<"guardianai.v1.compliance.GetScanConsentStatusRequest"> & {
  /**
   * @generated from field: string scanner_user_id = 1;
   */
  scannerUserId: string;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetScanConsentStatusRequest
 */
export type GetScanConsentStatusRequestJson = {
  /**
   * @generated from field: string scanner_user_id = 1;
   */
  scannerUserId?: string;

  /**
   * @generated from field: string target_entity_id = 2;
   */
  targetEntityId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetScanConsentStatusRequest.
 * Use `create(GetScanConsentStatusRequestSchema)` to create a new message.
 */
export const GetScanConsentStatusRequestSchema: GenMessage<GetScanConsentStatusRequest, {jsonType: GetScanConsentStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 38);

/**
 * @generated from message guardianai.v1.compliance.GetScanConsentStatusResponse
 */
export type GetScanConsentStatusResponse = Message<"guardianai.v1.compliance.GetScanConsentStatusResponse"> & {
  /**
   * @generated from field: bool has_active_consent = 1;
   */
  hasActiveConsent: boolean;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt: bigint;

  /**
   * @generated from field: string consent_token = 3;
   */
  consentToken: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetScanConsentStatusResponse
 */
export type GetScanConsentStatusResponseJson = {
  /**
   * @generated from field: bool has_active_consent = 1;
   */
  hasActiveConsent?: boolean;

  /**
   * @generated from field: int64 expires_at = 2;
   */
  expiresAt?: string;

  /**
   * @generated from field: string consent_token = 3;
   */
  consentToken?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetScanConsentStatusResponse.
 * Use `create(GetScanConsentStatusResponseSchema)` to create a new message.
 */
export const GetScanConsentStatusResponseSchema: GenMessage<GetScanConsentStatusResponse, {jsonType: GetScanConsentStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 39);

/**
 * @generated from message guardianai.v1.compliance.GenComplianceRequest
 */
export type GenComplianceRequest = Message<"guardianai.v1.compliance.GenComplianceRequest"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime: bigint;

  /**
   * @generated from field: string format = 4;
   */
  format: string;
};

/**
 * @generated from message guardianai.v1.compliance.GenComplianceRequest
 */
export type GenComplianceRequestJson = {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType?: string;

  /**
   * @generated from field: int64 start_time = 2;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 3;
   */
  endTime?: string;

  /**
   * @generated from field: string format = 4;
   */
  format?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GenComplianceRequest.
 * Use `create(GenComplianceRequestSchema)` to create a new message.
 */
export const GenComplianceRequestSchema: GenMessage<GenComplianceRequest, {jsonType: GenComplianceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 40);

/**
 * @generated from message guardianai.v1.compliance.GenFraudSummaryRequest
 */
export type GenFraudSummaryRequest = Message<"guardianai.v1.compliance.GenFraudSummaryRequest"> & {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime: bigint;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.GenFraudSummaryRequest
 */
export type GenFraudSummaryRequestJson = {
  /**
   * @generated from field: int64 start_time = 1;
   */
  startTime?: string;

  /**
   * @generated from field: int64 end_time = 2;
   */
  endTime?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GenFraudSummaryRequest.
 * Use `create(GenFraudSummaryRequestSchema)` to create a new message.
 */
export const GenFraudSummaryRequestSchema: GenMessage<GenFraudSummaryRequest, {jsonType: GenFraudSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 41);

/**
 * @generated from message guardianai.v1.compliance.FraudSummaryResponse
 */
export type FraudSummaryResponse = Message<"guardianai.v1.compliance.FraudSummaryResponse"> & {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports: number;

  /**
   * @generated from field: int32 confirmed_fraud = 2;
   */
  confirmedFraud: number;

  /**
   * @generated from field: double financial_impact = 3;
   */
  financialImpact: number;

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory: { [key: string]: number };
};

/**
 * @generated from message guardianai.v1.compliance.FraudSummaryResponse
 */
export type FraudSummaryResponseJson = {
  /**
   * @generated from field: int32 total_reports = 1;
   */
  totalReports?: number;

  /**
   * @generated from field: int32 confirmed_fraud = 2;
   */
  confirmedFraud?: number;

  /**
   * @generated from field: double financial_impact = 3;
   */
  financialImpact?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: map<string, int32> by_category = 4;
   */
  byCategory?: { [key: string]: number };
};

/**
 * Describes the message guardianai.v1.compliance.FraudSummaryResponse.
 * Use `create(FraudSummaryResponseSchema)` to create a new message.
 */
export const FraudSummaryResponseSchema: GenMessage<FraudSummaryResponse, {jsonType: FraudSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 42);

/**
 * @generated from message guardianai.v1.compliance.ScheduleReportRequest
 */
export type ScheduleReportRequest = Message<"guardianai.v1.compliance.ScheduleReportRequest"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * @generated from field: string cron_expression = 2;
   */
  cronExpression: string;

  /**
   * @generated from field: repeated string recipients = 3;
   */
  recipients: string[];
};

/**
 * @generated from message guardianai.v1.compliance.ScheduleReportRequest
 */
export type ScheduleReportRequestJson = {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType?: string;

  /**
   * @generated from field: string cron_expression = 2;
   */
  cronExpression?: string;

  /**
   * @generated from field: repeated string recipients = 3;
   */
  recipients?: string[];
};

/**
 * Describes the message guardianai.v1.compliance.ScheduleReportRequest.
 * Use `create(ScheduleReportRequestSchema)` to create a new message.
 */
export const ScheduleReportRequestSchema: GenMessage<ScheduleReportRequest, {jsonType: ScheduleReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 43);

/**
 * @generated from message guardianai.v1.compliance.ScheduleResponse
 */
export type ScheduleResponse = Message<"guardianai.v1.compliance.ScheduleResponse"> & {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.ScheduleResponse
 */
export type ScheduleResponseJson = {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId?: string;

  /**
   * @generated from field: bool success = 2;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.ScheduleResponse.
 * Use `create(ScheduleResponseSchema)` to create a new message.
 */
export const ScheduleResponseSchema: GenMessage<ScheduleResponse, {jsonType: ScheduleResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 44);

/**
 * @generated from message guardianai.v1.compliance.GetScheduledRequest
 */
export type GetScheduledRequest = Message<"guardianai.v1.compliance.GetScheduledRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.compliance.GetScheduledRequest
 */
export type GetScheduledRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.GetScheduledRequest.
 * Use `create(GetScheduledRequestSchema)` to create a new message.
 */
export const GetScheduledRequestSchema: GenMessage<GetScheduledRequest, {jsonType: GetScheduledRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 45);

/**
 * @generated from message guardianai.v1.compliance.ScheduledReportsResponse
 */
export type ScheduledReportsResponse = Message<"guardianai.v1.compliance.ScheduledReportsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ScheduledReport reports = 1;
   */
  reports: ScheduledReport[];
};

/**
 * @generated from message guardianai.v1.compliance.ScheduledReportsResponse
 */
export type ScheduledReportsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ScheduledReport reports = 1;
   */
  reports?: ScheduledReportJson[];
};

/**
 * Describes the message guardianai.v1.compliance.ScheduledReportsResponse.
 * Use `create(ScheduledReportsResponseSchema)` to create a new message.
 */
export const ScheduledReportsResponseSchema: GenMessage<ScheduledReportsResponse, {jsonType: ScheduledReportsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 46);

/**
 * @generated from message guardianai.v1.compliance.ScheduledReport
 */
export type ScheduledReport = Message<"guardianai.v1.compliance.ScheduledReport"> & {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId: string;

  /**
   * @generated from field: string report_type = 2;
   */
  reportType: string;

  /**
   * @generated from field: string cron_expression = 3;
   */
  cronExpression: string;

  /**
   * @generated from field: int64 next_run = 4;
   */
  nextRun: bigint;
};

/**
 * @generated from message guardianai.v1.compliance.ScheduledReport
 */
export type ScheduledReportJson = {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId?: string;

  /**
   * @generated from field: string report_type = 2;
   */
  reportType?: string;

  /**
   * @generated from field: string cron_expression = 3;
   */
  cronExpression?: string;

  /**
   * @generated from field: int64 next_run = 4;
   */
  nextRun?: string;
};

/**
 * Describes the message guardianai.v1.compliance.ScheduledReport.
 * Use `create(ScheduledReportSchema)` to create a new message.
 */
export const ScheduledReportSchema: GenMessage<ScheduledReport, {jsonType: ScheduledReportJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 47);

/**
 * @generated from message guardianai.v1.compliance.CancelReportRequest
 */
export type CancelReportRequest = Message<"guardianai.v1.compliance.CancelReportRequest"> & {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId: string;
};

/**
 * @generated from message guardianai.v1.compliance.CancelReportRequest
 */
export type CancelReportRequestJson = {
  /**
   * @generated from field: string schedule_id = 1;
   */
  scheduleId?: string;
};

/**
 * Describes the message guardianai.v1.compliance.CancelReportRequest.
 * Use `create(CancelReportRequestSchema)` to create a new message.
 */
export const CancelReportRequestSchema: GenMessage<CancelReportRequest, {jsonType: CancelReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 48);

/**
 * @generated from message guardianai.v1.compliance.CancelReportResponse
 */
export type CancelReportResponse = Message<"guardianai.v1.compliance.CancelReportResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.compliance.CancelReportResponse
 */
export type CancelReportResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.compliance.CancelReportResponse.
 * Use `create(CancelReportResponseSchema)` to create a new message.
 */
export const CancelReportResponseSchema: GenMessage<CancelReportResponse, {jsonType: CancelReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 49);

/**
 * @generated from message guardianai.v1.compliance.GetTemplatesRequest
 */
export type GetTemplatesRequest = Message<"guardianai.v1.compliance.GetTemplatesRequest"> & {
};

/**
 * @generated from message guardianai.v1.compliance.GetTemplatesRequest
 */
export type GetTemplatesRequestJson = {
};

/**
 * Describes the message guardianai.v1.compliance.GetTemplatesRequest.
 * Use `create(GetTemplatesRequestSchema)` to create a new message.
 */
export const GetTemplatesRequestSchema: GenMessage<GetTemplatesRequest, {jsonType: GetTemplatesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 50);

/**
 * @generated from message guardianai.v1.compliance.TemplatesResponse
 */
export type TemplatesResponse = Message<"guardianai.v1.compliance.TemplatesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ReportTemplate templates = 1;
   */
  templates: ReportTemplate[];
};

/**
 * @generated from message guardianai.v1.compliance.TemplatesResponse
 */
export type TemplatesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.compliance.ReportTemplate templates = 1;
   */
  templates?: ReportTemplateJson[];
};

/**
 * Describes the message guardianai.v1.compliance.TemplatesResponse.
 * Use `create(TemplatesResponseSchema)` to create a new message.
 */
export const TemplatesResponseSchema: GenMessage<TemplatesResponse, {jsonType: TemplatesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 51);

/**
 * @generated from message guardianai.v1.compliance.ReportTemplate
 */
export type ReportTemplate = Message<"guardianai.v1.compliance.ReportTemplate"> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string supported_formats = 4;
   */
  supportedFormats: string[];
};

/**
 * @generated from message guardianai.v1.compliance.ReportTemplate
 */
export type ReportTemplateJson = {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated string supported_formats = 4;
   */
  supportedFormats?: string[];
};

/**
 * Describes the message guardianai.v1.compliance.ReportTemplate.
 * Use `create(ReportTemplateSchema)` to create a new message.
 */
export const ReportTemplateSchema: GenMessage<ReportTemplate, {jsonType: ReportTemplateJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_compliance_compliance, 52);

/**
 * @generated from enum guardianai.v1.compliance.DsrType
 */
export enum DsrType {
  /**
   * @generated from enum value: DSR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DSR_TYPE_ACCESS = 1;
   */
  ACCESS = 1,

  /**
   * @generated from enum value: DSR_TYPE_ERASURE = 2;
   */
  ERASURE = 2,

  /**
   * @generated from enum value: DSR_TYPE_RECTIFICATION = 3;
   */
  RECTIFICATION = 3,

  /**
   * @generated from enum value: DSR_TYPE_PORTABILITY = 4;
   */
  PORTABILITY = 4,
}

/**
 * @generated from enum guardianai.v1.compliance.DsrType
 */
export type DsrTypeJson = "DSR_TYPE_UNSPECIFIED" | "DSR_TYPE_ACCESS" | "DSR_TYPE_ERASURE" | "DSR_TYPE_RECTIFICATION" | "DSR_TYPE_PORTABILITY";

/**
 * Describes the enum guardianai.v1.compliance.DsrType.
 */
export const DsrTypeSchema: GenEnum<DsrType, DsrTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_compliance_compliance, 0);

/**
 * @generated from service guardianai.v1.compliance.AuditService
 */
export const AuditService: GenService<{
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.LogEvent
   */
  logEvent: {
    methodKind: "unary";
    input: typeof LogEventRequestSchema;
    output: typeof LogEventResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.GetAuditLog
   */
  getAuditLog: {
    methodKind: "unary";
    input: typeof GetAuditLogRequestSchema;
    output: typeof AuditLogResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.SearchAuditLogs
   */
  searchAuditLogs: {
    methodKind: "unary";
    input: typeof SearchLogsRequestSchema;
    output: typeof AuditLogResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.GetUserActivity
   */
  getUserActivity: {
    methodKind: "unary";
    input: typeof GetUserActivityRequestSchema;
    output: typeof UserActivityResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.ExportAuditLog
   */
  exportAuditLog: {
    methodKind: "unary";
    input: typeof ExportLogRequestSchema;
    output: typeof ExportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.GetAuditSummary
   */
  getAuditSummary: {
    methodKind: "unary";
    input: typeof GetSummaryRequestSchema;
    output: typeof AuditSummaryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.SetRetentionPolicy
   */
  setRetentionPolicy: {
    methodKind: "unary";
    input: typeof SetRetentionRequestSchema;
    output: typeof RetentionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.GetRetentionPolicy
   */
  getRetentionPolicy: {
    methodKind: "unary";
    input: typeof GetRetentionRequestSchema;
    output: typeof RetentionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.PurgeOldLogs
   */
  purgeOldLogs: {
    methodKind: "unary";
    input: typeof PurgeLogsRequestSchema;
    output: typeof PurgeResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.AuditService.GetComplianceReport
   */
  getComplianceReport: {
    methodKind: "unary";
    input: typeof GetCompReportRequestSchema;
    output: typeof ComplianceReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_compliance_compliance, 0);

/**
 * @generated from service guardianai.v1.compliance.ConsentService
 */
export const ConsentService: GenService<{
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.RecordConsent
   */
  recordConsent: {
    methodKind: "unary";
    input: typeof RecordConsentRequestSchema;
    output: typeof ConsentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.GetConsentStatus
   */
  getConsentStatus: {
    methodKind: "unary";
    input: typeof GetConsentRequestSchema;
    output: typeof ConsentStatusResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.RevokeConsent
   */
  revokeConsent: {
    methodKind: "unary";
    input: typeof RevokeConsentRequestSchema;
    output: typeof RevokeResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.GetConsentHistory
   */
  getConsentHistory: {
    methodKind: "unary";
    input: typeof GetConsentHistoryRequestSchema;
    output: typeof ConsentHistoryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.GetActiveConsents
   */
  getActiveConsents: {
    methodKind: "unary";
    input: typeof GetActiveConsentsRequestSchema;
    output: typeof ActiveConsentsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ConsentService.UpdateConsentPreferences
   */
  updateConsentPreferences: {
    methodKind: "unary";
    input: typeof UpdatePreferencesRequestSchema;
    output: typeof PreferencesResponseSchema;
  },
  /**
   * DSR alias for frontend compatibility (also available on DataSubjectRightsService)
   *
   * @generated from rpc guardianai.v1.compliance.ConsentService.HandleDsrRequest
   */
  handleDsrRequest: {
    methodKind: "unary";
    input: typeof DsrRequestSchema;
    output: typeof DsrResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_compliance_compliance, 1);

/**
 * @generated from service guardianai.v1.compliance.ScanConsentService
 */
export const ScanConsentService: GenService<{
  /**
   * @generated from rpc guardianai.v1.compliance.ScanConsentService.RequestScanConsent
   */
  requestScanConsent: {
    methodKind: "unary";
    input: typeof RequestScanConsentRequestSchema;
    output: typeof RequestScanConsentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ScanConsentService.VerifyScanConsent
   */
  verifyScanConsent: {
    methodKind: "unary";
    input: typeof VerifyScanConsentRequestSchema;
    output: typeof VerifyScanConsentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ScanConsentService.GetScanConsentStatus
   */
  getScanConsentStatus: {
    methodKind: "unary";
    input: typeof GetScanConsentStatusRequestSchema;
    output: typeof GetScanConsentStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_compliance_compliance, 2);

/**
 * @generated from service guardianai.v1.compliance.ReportService
 */
export const ReportService: GenService<{
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.GenerateComplianceReport
   */
  generateComplianceReport: {
    methodKind: "unary";
    input: typeof GenComplianceRequestSchema;
    output: typeof ComplianceReportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.GenerateFraudSummary
   */
  generateFraudSummary: {
    methodKind: "unary";
    input: typeof GenFraudSummaryRequestSchema;
    output: typeof FraudSummaryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.ScheduleReport
   */
  scheduleReport: {
    methodKind: "unary";
    input: typeof ScheduleReportRequestSchema;
    output: typeof ScheduleResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.GetScheduledReports
   */
  getScheduledReports: {
    methodKind: "unary";
    input: typeof GetScheduledRequestSchema;
    output: typeof ScheduledReportsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.CancelScheduledReport
   */
  cancelScheduledReport: {
    methodKind: "unary";
    input: typeof CancelReportRequestSchema;
    output: typeof CancelReportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.compliance.ReportService.GetReportTemplates
   */
  getReportTemplates: {
    methodKind: "unary";
    input: typeof GetTemplatesRequestSchema;
    output: typeof TemplatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_compliance_compliance, 3);

/**
 * @generated from service guardianai.v1.compliance.DataSubjectRightsService
 */
export const DataSubjectRightsService: GenService<{
  /**
   * @generated from rpc guardianai.v1.compliance.DataSubjectRightsService.HandleDsrRequest
   */
  handleDsrRequest: {
    methodKind: "unary";
    input: typeof DsrRequestSchema;
    output: typeof DsrResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_compliance_compliance, 4);

